import React from "react";
import { map, sumBy } from "lodash";

import OnePanel from "./OnePanel";
import Text from "./Text";
import Title from "./Title";
import MarketCaptureChart from "instructor/components/charts/market-capture-chart";
import { numberFormat } from "./format";
import { teamColors, pickValue } from "./utils";
import Auth from "routes/Auth";

const MarketingAnalysis1 = ({
  competitiveAnalysis,
  teams,
  competitiveAnalysisTeam,
  totalDemand,
  competitionMetrics
}) => {
  const data =
    Auth.getPosition() === "Student" ? competitiveAnalysis : competitionMetrics;
  const team = competitiveAnalysisTeam;
  const unitsSold = sumBy(data, team => -team["Units Sold"]);
  const totalDemandAuto = totalDemand.auto;
  const totalDemandMobile = totalDemand.mobile;
  const colors = teamColors(teams, data);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <OnePanel title="Market Capture" style={{ flex: "1" }}>
        <Text>
          In this round, the market demanded{" "}
          {numberFormat(team["Market Demand"])} units of image sensors and
          overall units sold were {numberFormat(unitsSold)}.
        </Text>
        <Text>
          Your team was able to capture{" "}
          {((-team["Units Sold"] / unitsSold) * 100).toFixed(1)}% of the overall
          units sold.
        </Text>
        <Text>
          You had{" "}
          {numberFormat(team["Available For Sale"] + team["Units Sold"])} units
          of inventory remaining.
        </Text>
      </OnePanel>
      <div style={{ flex: "1" }}>
        <Title style={{ textAlign: "center" }}>MARKET CAPTURE - MOBILE</Title>
        <MarketCaptureChart
          data={map(pickValue(teams, data, "Units Sold Mobile"), item => ({
            ...item,
            value: -item.value
          }))}
          colors={colors}
          totalDemand={totalDemandMobile}
        />
        <Title style={{ textAlign: "center" }}>MARKET CAPTURE - AUTO</Title>
        <MarketCaptureChart
          data={map(pickValue(teams, data, "Units Sold Auto"), item => ({
            ...item,
            value: -item.value
          }))}
          colors={colors}
          totalDemand={totalDemandAuto}
        />
      </div>
    </div>
  );
};

export default MarketingAnalysis1;



// WEBPACK FOOTER //
// ./src/components/analysis/MarketingAnalysis1.js